import React from 'react';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { Section, CTAButton } from './Shared';
export const Pricing = () => {
  return <Section id="pricing" className="bg-brand-surfaceLight/30 rounded-3xl my-12" data-id="element-227">
      <div className="max-w-xl mx-auto" data-id="element-228">
        <div className="glass-panel rounded-3xl p-8 md:p-10 flex flex-col border-brand-rose relative shadow-[0_10px_40px_rgba(212,115,140,0.15)] bg-white/80 text-center" data-id="element-229">
          <div className="mb-6" data-id="element-230">
            <h4 className="text-2xl font-serif font-bold mb-2 text-brand-text" data-id="element-231">
              KIT REFLEXO-PRO COMPLETO
            </h4>
            <p className="text-brand-rose/90 font-medium" data-id="element-232">
              Tomo Principal + Bonus 1 + Bonus 2 · 110 páginas
            </p>
          </div>

          <div className="mb-8" data-id="element-233">
            <div className="text-xl text-brand-text/50 line-through mb-1" data-id="element-234">
              $62.000 ARS
            </div>
            <div className="text-5xl font-bold text-brand-text mb-2" data-id="element-235">
              $15.990
            </div>
          </div>

          <div className="mt-auto" data-id="element-236">
            <CTAButton fullWidth className="text-lg py-5 animate-pulse-slow" href="https://www.lumenakasha.com/cart/46722804678845:1" data-id="element-237">
              🦶 → QUIERO MI KIT REFLEXO-PRO AHORA
            </CTAButton>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap mt-12 text-sm text-brand-muted flex-row items-start justify-center gap-[10px]" data-id="element-238">
        <div className="flex items-center" data-id="element-239">
          <Lock className="w-4 h-4 mr-2" data-id="element-240" /> Pago 100% seguro
        </div>
        <div className="flex items-center" data-id="element-241">
          <Zap className="w-4 h-4 mr-2" data-id="element-242" /> Acceso en 5 minutos
        </div>
        <div className="flex items-center" data-id="element-243">
          <Shield className="w-4 h-4 mr-2" data-id="element-244" /> Garantía 7 días
        </div>
        <div className="flex items-center" data-id="element-245">
          <CreditCard className="w-4 h-4 mr-2" data-id="element-246" /> Mercado Pago | Tarjeta |
          Transferencia
        </div>
      </div>
    </Section>;
};